import { Divider as MUIDivider, DividerProps } from '@mui/material';
import { memo } from 'react';
import { S3 } from '../../theme';
import { mergeSX } from '../../services/helpers';

const buildSX = () => ({
  '&.MuiDivider-root': {
    borderBottomWidth: '1px',
    color: S3,
  },
});
const Divider = (props: DividerProps) => {
  const { sx, ...restProps } = props;
  return <MUIDivider sx={mergeSX(buildSX(), sx)} {...restProps} />;
};

export default memo(Divider);
